export default class HttpProviderError extends Error {
  constructor(status, headers, result, message = null, isAborted = false) {
    super()
    this.name = 'HttpProviderError'
    this.message = message
    this.response = {
      status,
      headers,
      result,
      isAborted,
    }
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      response: this.response,
      stack: this.stack,
    }
  }
}
